import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { constants } from 'src/environments/constants';
import { AnalyticsService, AnalyticsUtility } from 'src/app/services/analytics/analytics.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { FilterMappingService } from 'src/app/services/results/filter-mapping.service';

@Component({
  selector: 'app-os-type-filters',
  templateUrl: './os-type-filters.component.html',
  styleUrls: ['./os-type-filters.component.scss']
})
export class OsTypeFiltersComponent implements OnChanges {
  @Input() isEnterpriseWorkflow: boolean = false;
  @Output() setInitialSelectedOsTypes: EventEmitter<string[]> = new EventEmitter();
  @Output() osTypesToFilterBy: EventEmitter<string[]> = new EventEmitter();
  selectedOsTypes: string[] = [];
  title: string = "";
  enterpriseKeyword: string = "";
  enterpriseLabel: string = "";
  nonEnterpriseKeyword: string = "";
  nonEnterpriseLabel: string = "";
  enterpriseWorkflowSetupHasRun: boolean = false;

  constructor(private analytics: AnalyticsService, private confSvc: ConfigService, private filterMapper: FilterMappingService) { }

  ngOnChanges(changes: SimpleChanges) {
    // This is needed instead of doing setup in ngOnInit because the isEnterpriseWorkflow Input can change after ngOnInit runs,
    // and we only want to use this component if isEnterpriseWorkflow. We can't simply have an *ngIf="isEnterpriseWorkflow" in the parent
    // of this component because for desktop this component is named and referenced by the filter-chips component, and
    // named components are only accessible if not conditionally added to the template
    if ((changes.isEnterpriseWorkflow.currentValue === true) && !this.enterpriseWorkflowSetupHasRun) {
      this.runEnterpriseWorkflowSetup();
    }
  }

  async runEnterpriseWorkflowSetup(): Promise<void> {
    await this.confSvc.setup();

    this.title = this.confSvc.getString("osTypesFilterTitle");
    this.enterpriseKeyword = constants.ENTERPRISE;
    this.enterpriseLabel = this.filterMapper.getOsTypeFilterLabel(this.enterpriseKeyword);
    this.nonEnterpriseKeyword = constants.NON_ENTERPRISE;
    this.nonEnterpriseLabel = this.filterMapper.getOsTypeFilterLabel(this.nonEnterpriseKeyword);

    this.selectedOsTypes = [constants.ENTERPRISE, constants.NON_ENTERPRISE];
    this.setInitialSelectedOsTypes.emit(this.selectedOsTypes);

    this.enterpriseWorkflowSetupHasRun = true;
  }

  osTypeIsSelected(osType: string): boolean {
    return this.selectedOsTypes.some(type => type === osType);
  }

  onOsTypeChange(osType: string): void {
    const indexOfOsType = this.selectedOsTypes.indexOf(osType);
    indexOfOsType < 0 ? this.selectedOsTypes.push(osType) : this.selectedOsTypes.splice(indexOfOsType, 1);
    this.osTypesToFilterBy.emit(this.selectedOsTypes);
    this.analytics.logCheckboxFilterClick(AnalyticsUtility.filterType.osType, osType, indexOfOsType < 0);
  }
}
